// The socket and REST server. Production names it in .env.production; in dev
// it is the machine that served the page, on port 4000, so the same build works
// on the laptop (localhost) and on a phone on the same wifi (its LAN address).
export const API_BASE =
  process.env.REACT_APP_API_BASE ||
  `${window.location.protocol}//${window.location.hostname}:4000`;
